import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SearchInput from "../common/FormInputs/SearchInput";
import { setSearchText } from "../redux/slices/isSearch";
import { roleNames } from "../constant";

const Header = () => {
  const { pathname } = useLocation();
  const role = useSelector((state) => state.auth.role);
  const searchText = useSelector((state) => state.search.searchText);
  const dispatch = useDispatch();
  const location = useLocation();

  // console.log("searchText", searchText);

  const handleSearch = (event) => {
    dispatch(setSearchText(event.target.value));
  };

  useEffect(() => {
    dispatch(setSearchText(""));
  }, [location.pathname]);

  return (
    <>
      <div className="welcom-main px-2 py-2 pt-4 pt-lg-0 mb-3 d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-between align-items-center">
        <div className="">
          {pathname === "/manage-qas" ? (
            <div className="welcome" style={{ fontFamily: "Gilroy-Medium" }}>
              <span className="superAdmin">Manage QAs</span>
              <br />
              <span className="welcomeback">Add, edit, or remove QA reviewers</span>
            </div>
          ) : (
            <div className="welcome" style={{ fontFamily: "Gilroy-Medium" }}>
              <span className="welcomeback">Welcome back,</span>
              <br />
              <span className="superAdmin" style={{ whiteSpace: "nowrap" }}>
                {role == roleNames.qa ? "Quality Analyst" : "Super Admin"}
              </span>
            </div>
          )}
        </div>
        <div className="d-flex w-100 w-md-50 justify-content-end">
          <div className="search-container">
            <SearchInput onSearch={handleSearch} value={searchText} />
          </div>
          <div className="d-flex align-items-center gap-3 notification-user-container">
            <button type="button" className="btn btn-link p-0 notification-btn">
              <i className="bi bi-bell"></i>
            </button>
            <img
              src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe"
              alt="User Avatar"
              className="user-avatar"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
